"use client";

import { createContext, useContext } from "react";

const PersistentHeaderContext = createContext(false);

export function PersistentHeaderProvider({
  children,
  enabled,
}: {
  children: React.ReactNode;
  enabled: boolean;
}) {
  return (
    <PersistentHeaderContext.Provider value={enabled}>
      {children}
    </PersistentHeaderContext.Provider>
  );
}

export function usePersistentHeaderEnabled() {
  return useContext(PersistentHeaderContext);
}
